import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

const LiveClock = ({ className }) => {
    const [now, setNow] = useState(new Date());

    const [timeZone, setTimeZone] = useState(() => {
        try {
            return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
        } catch (e) {
            return "UTC";
        }
    });

    useEffect(() => {
        try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (tz && tz != timeZone) {
                setTimeZone(tz);
            }
        } catch (e) {}
    }, [timeZone]);

    useEffect(() => {
        const interval = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const timeOptions = {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone,
    };

    const currentTime = new Intl.DateTimeFormat("en-US", timeOptions).format(
        now,
    );

    return <p className={twMerge("tabular-nums", className)}>{currentTime}</p>;
};

export default LiveClock;
